/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './equipment-ip.reducer';

export const EquipmentIPDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const equipmentIPEntity = useAppSelector(state => state.equipmentIP.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="equipmentIPDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.equipmentIP.detail.title">EquipmentIP</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.id">Id</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.id}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.active">Active</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="charge">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.charge">Charge</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.charge}</dd>
          <dt>
            <span id="chargeType">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.chargeType">Charge Type</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.chargeType}</dd>
          <dt>
            <span id="allotted">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.allotted">Allotted</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.allotted ? 'true' : 'false'}</dd>
          <dt>
            <span id="supended">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.supended">Supended</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.supended ? 'true' : 'false'}</dd>
          <dt>
            <span id="expiryDate">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.expiryDate">Expiry Date</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.expiryDate}</dd>
          <dt>
            <span id="maxUses">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.maxUses">Max Uses</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.maxUses}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.notes}</dd>
          <dt>
            <span id="deviceNo">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.deviceNo">Device No</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.deviceNo}</dd>
          <dt>
            <span id="deviceName">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.deviceName">Device Name</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.deviceName}</dd>
          <dt>
            <span id="mfdDate">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.mfdDate">Mfd Date</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.mfdDate}</dd>
          <dt>
            <span id="dateSupended">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.dateSupended">Date Supended</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.dateSupended}</dd>
          <dt>
            <span id="reasonSupended">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.reasonSupended">Reason Supended</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.reasonSupended}</dd>
          <dt>
            <span id="maintainanceCycle">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.maintainanceCycle">Maintainance Cycle</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.maintainanceCycle}</dd>
          <dt>
            <span id="lastMaintenanceDate">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.lastMaintenanceDate">Last Maintenance Date</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.lastMaintenanceDate}</dd>
          <dt>
            <span id="tax">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.tax">Tax</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.tax}</dd>
          <dt>
            <span id="underMaintainance">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.underMaintainance">Under Maintainance</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.underMaintainance ? 'true' : 'false'}</dd>
          <dt>
            <span id="equipmentType">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.equipmentType">Equipment Type</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.equipmentType}</dd>
          <dt>
            <span id="location">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.location">Location</Translate>
            </span>
          </dt>
          <dd>{equipmentIPEntity.location}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentIP.device">Device</Translate>
          </dt>
          <dd>{equipmentIPEntity.device ? equipmentIPEntity.device.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentIP.hospital">Hospital</Translate>
          </dt>
          <dd>{equipmentIPEntity.hospital ? equipmentIPEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentIP.addedBy">Added By</Translate>
          </dt>
          <dd>{equipmentIPEntity.addedBy ? equipmentIPEntity.addedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentIP.modifiedBy">Modified By</Translate>
          </dt>
          <dd>{equipmentIPEntity.modifiedBy ? equipmentIPEntity.modifiedBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/equipment-ip" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/equipment-ip/${equipmentIPEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EquipmentIPDetail;
